export const cronOptions = [
    { key: '0/10 * * * *', value: '0/10 * * * *', text: 'Every 10 Minutes' },
    { key: '0/20 * * * *', value: '0/20 * * * *', text: 'Every 20 Minutes' },
    { key: '0/30 * * * *', value: '0/30 * * * *', text: 'Every 30 Minutes' },
    { key: '0 0/1 * * *', value: '0 0/1 * * *', text: 'Every 1 Hour' },
    { key: '0 0/2 * * *', value: '0 0/2 * * *', text: 'Every 2 Hour' },
    { key: '0 0/3 * * *', value: '0 0/3 * * *', text: 'Every 3 Hour' },
    { key: '0 0/6 * * *', value: '0 0/6 * * *', text: 'Every 6 Hour' },
    { key: '59 */11 * * *', value: '59 */11 * * *', text: 'Every 12 Hour' },
    { key: '0 0 * * *', value: '0 0 * * *', text: 'Daily ( At 12:00 PM UTC )' },
    { key: '0 0 * * 0', value: '0 0 * * 0', text: 'Weekly ( At 12:00 PM UTC on Sunday )' },
];
//# sourceMappingURL=cron-expressions.js.map